<template>
  <div class="container d-none d-md-block">
    <div class="row align-items-center justify-content-center preview-img-list">
      <div
        class="col-sm-12 col-md-6 col-lg-4 col-xl-3 text-center pb-2 pt-2"
        v-for="(photo) in slides"
        :key="photo.pid"
        @click="$photoswipe.open(photo.i, slides)"
      >
        <img :src="photo.galleryPath" class="preview-img-item">
      </div>
    </div>
  </div>
</template>

<style scoped>
.preview-img-item {
  cursor: zoom-in;
}
img {
  width: 100%;
  max-height: 100vh;
}

@media (min-width: 576px) {
  img {
    width: auto;
    max-width: 100%;
    max-height: 95vh;
  }
}
</style>

<script>
// import GalleryPhoto from '@/components/gallery/GalleryPhoto.vue'
export default {
  props: ['photos'],
  data() {
    return {
      items: [],
      url: []
    }
  },
  components: {},
  computed: {
    // convert the photo object to an array
    slides: function() {
      let photos = []
      const photoArray = Object.values(this.photos)
      let i = 0
      photoArray.forEach(photo => {
        let slide = {
          i: i,
          src: photo.filePath,
          w: photo.width,
          h: photo.height,
          ...photo
        }
        photos.push(slide)
        i++
      })
      return photos
    }
  },
  methods: {},
  mounted() {
    // console.log(this.photos)
  }
}
</script>
